import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BookReader from './pages/bookReader';
import HomePage from './pages/homePage';
import PremiumPage from './pages/pricing';
import ContactUsPage from './pages/contactUs';
import PremiumDetailsPage from './pages/premiumDetails';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/read_book/:book_id" element={<BookReader />} />
        <Route path="/pricing" element={<PremiumPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/premium" element={<PremiumDetailsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
